export default __webpack_public_path__ + "static/media/HqO-text-white.a024a3f4.png";